<template>
  <div class="animated fadeIn systemcss">
    <div class="row">
      <div class="col-sm-12">
        <userform v-bind:title="$t('NEWUSER')"
          v-bind:formData="formData"
          v-bind:formError="formError"
          v-bind:aclGroups="aclGroups"
          v-bind:status="status"
          v-bind:company="company"
          v-bind:newuser="true" v-on:saveRow="saveRow"></userform>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
               <strong>{{$t('USERS')}}</strong>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-3">
                  <b-form-fieldset v-bind:label="$t('SEARCH')">
                    <b-form-input v-model="pagination.query"></b-form-input>
                  </b-form-fieldset>
                </div>
                <div class="col-sm-3">
                  <b-form-fieldset v-bind:label="$t('COMPANY')">
                      <lb-vue-select v-model= "companyFilter"
                                      :list= "company.root"
                                      display-field= "companyName"
                                      value-field= "companyId">
                        </lb-vue-select>
                  </b-form-fieldset>
                </div>
                <div class="col-sm-2 mt-4">
                  <button type="button" class="btn btn-primary button-add pull-right" @click="showNotificationModal()">{{$t('NEWNOTIFICATION')}}</button>
                </div>
              </div>
            </div>
            <div class="card-body" v-if="typeof data.root == 'undefined' || !data.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="card-body" v-if="typeof data.root != 'undefined' && data.root.length">
              <table class="table table-responsive-sm table-striped table-logoped">
                <thead>
                  <tr>
                    <th>{{$t('ID')}}</th>
                    <th>{{$t('USERNAME')}}</th>
                    <th>{{$t('USEREMAIL')}}</th>
                    <th>{{$t('NAME')}}</th>
                    <th>{{$t('SURNAME')}}</th>
                    <th>{{$t('COMPANYNAME')}}</th>
                    <th>{{$t('ACTION')}}</th>
                    <th>{{$t('DELETE')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="item in data.root">
                    <tr :key="'grid_'+item.userId">
                      <td>{{item.userId}}</td>
                      <td>{{item.username}}</td>
                      <td>{{item.userEmail}}</td>
                      <td>{{item.name}}</td>
                      <td>{{item.surname}}</td>
                      <td>{{item.companyName}}</td>
                      <td><b-button type="reset" class="btn button-edit" v-on:click.prevent="item.trhidden = !item.trhidden">{{$t('EDIT')}}</b-button></td>
                      <td><b-button type="reset" class="btn button-dlt" v-on:click.prevent="deleteRow(item.userId)">{{$t('DELETE')}}</b-button></td>
                    </tr>
                    <tr :key="'form_'+item.userId" v-if="item.trhidden">
                      <td colspan="8">
                        <userform v-bind:title="$t('EDITUSER')+' '+item.username"
                          v-bind:formData="item"
                          v-bind:formError="formError"
                          v-bind:aclGroups="aclGroups"
                          v-bind:newuser="false"
                          v-bind:company="company"
                          v-on:saveRow="saveRow"
                          v-bind:status="status"></userform>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <nav>
                <b-pagination align="center" :total-rows="parseInt(data.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
              </nav>
            </div>
          </div>
        </div>
    </div>
    <b-modal ref="formnotificationmodal" :title="$t('NOTIFICATION')" ok-title="submit" centered hide-footer no-close-on-backdrop>
      <div class="d-block">
        <notificationmodal
          v-bind:formData="notificationFormData"
          v-bind:formError="formNotificationError"></notificationmodal>
      </div>
      <div class="text-right">
        <b-btn class="mr-2 button-cancel" @click="hideNotificationModal()">{{$t('CANCEL')}}</b-btn>
        <b-btn class="button-save" @click="submitNotification(notificationFormData)">{{$t('SENDNOTIFICATION')}}</b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>

import Api from '@/api/admin/Users';
import NotesApi from '@/api/notes/Note';
import CompanyApi from '@/api/admin/UserCompanies';
import AclGroupsApi from '@/api/admin/AclGroups';
import UsersForm from './UsersForm.vue';
import NotificationModal from './NotificationModal.vue';

export default {
    name: 'Users',
    components:
  {
      userform: UsersForm,
      notificationmodal: NotificationModal,
  },
    data()
    {
        const me = this;
        return {
            data: {},
            aclGroups: {},
            formError: {},
            company: {},
            formData:
      {
          username: '',
          password: '',
          userEmail: '',
          userGroup: 2,
          companyId: 1,
          status: 'active',
          name: '',
          surname: '',
          address: '',
          city: '',
          postalCode: '',
          country: '',
          phone: '',
          oibNum: '',
          userColor: '',
          title: '',
      },
            status:
      [
          {
              value: 'active',
              text: me.$i18n.t('ACTIVE'),
          },
          {
              value: 'inactive',
              text: me.$i18n.t('INACTIVE'),
          },
      ],
            companyFilter: null,
            pagination:
      {
          query: '',
          currentPage: 1,
          limit: 20,
          searchTimeout: false,
      },
            formNotificationError: {},
            notificationFormData:
      {
          title: '',
          text: '',
      },
        };
    },
    created()
    {
        const me = this;
        me.getData();
        me.getAclGroups();
        me.getUserCompany();
    },
    methods:
  {
      getAclGroups()
      {
          const me = this;
          AclGroupsApi.selectRow(me.getGroupParams, (data) =>
          {
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  return;
              }
              me.aclGroups = data;
          });
      },
      async getData()
      {
          const me = this;
          try
          {
              const data = await Api.selectRow(me.getParams);

              if (data.error && data.error === true)
              {
                  throw (data);
              }

              for (let i = 0; i < data.root.length; i += 1)
              {
                  data.root[i].password = '';
                  data.root[i].trhidden = false;
              }

              me.data = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
      async getUserCompany()
      {
          const me = this;
          try
          {
              const data = await CompanyApi.selectRow();

              if (data.error && data.error === true)
              {
                  throw (data);
              }

              data.root.unshift({ companyId: null, companyName: 'None' });

              me.company = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
      async saveRow(item)
      {
          const me = this;

          if (typeof item.userId !== 'undefined')
          {
              item.id = item.userId;
              delete (item.userId);
          }

          const data = await Api.save(item);

          if (data.error)
          {
              me.$notify.notice(data);
              me.formError = data;
          }
          else
          {
              me.$notify.notice(data);
              me.formError = {};
              await me.getData();
          }
      },
      deleteRow(id)
      {
          const me = this;
          me.$store.commit('setModalAlert',
              {
                  text: me.$i18n.t('AREYOUSHURE'),
                  btnAction()
                  {
                      Api.deleteRow({ id }, (data) =>
                      {
                          me.$notify.notice(data);
                          me.getData();
                      });
                  },
              });
      },
      showNotificationModal()
      {
          const me = this;
          me.$refs.formnotificationmodal.show();
      },
      async submitNotification(item)
      {
          const me = this;
          try
          {
              const data = await NotesApi.sendNotification(item);
              if (data.error)
              {
                  me.$notify.notice(data);
                  me.formNotificationError = data;
              }
              else
              {
                  me.$notify.notice(data);
                  me.hideNotificationModal();
              }
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      hideNotificationModal()
      {
          const me = this;
          this.$refs.formnotificationmodal.hide();

          me.notificationFormData = {
              title: '',
              text: '',
          };
      },
  },
    watch:
  {
      'pagination.currentPage'()
      {
          const me = this;
          me.getData();
      },
      'pagination.query'()
      {
          const me = this;

          if (me.pagination.searchTimeout !== false)
          {
              clearTimeout(me.pagination.searchTimeout);
          }

          me.pagination.searchTimeout = setTimeout(() =>
          {
              me.getData();
              me.pagination.searchTimeout = false;
          }, 300);
      },
      companyFilter()
      {
          const me = this;
          me.getData();
      },
  },
    computed:
  {
      getParams()
      {
          const me = this;
          const data = { ...me.pagination };
          data.start = (data.currentPage - 1) * data.limit;
          data.allUsers = true;
          if (me.companyFilter !== null)
          {
              data.companyId = me.companyFilter;
          }
          return data;
      },
  },
};
</script>
